// extracted by mini-css-extract-plugin
module.exports = {"SwipeLeftToClose":"xs_a bag_bk bag_bl bag_bo","SwipeLeftToClose--animating":"xs_b"};